<template>
  <div>
    <v-order-detail orderPayType="shop"></v-order-detail>
  </div>
</template>

<script>
import OrderDetail from "@/components/OrderDetail";
export default {
  name: "shopDetailOrder",
  components: {
    "v-order-detail": OrderDetail
  }
};
</script>